import styled from 'styled-components';
import { Maintitle, Smalltext, flexcenter } from '../../../font-variable';

const MembershipBody = styled.div`
  ${flexcenter};
  background-color: var(--background-color);
  height: 100%;
`;

const MembershipWrap = styled.div`
  max-width: 420px;
  width: 100%;
  margin: auto;
  padding: 50px 10px;
  text-align: center;
`;

const MembershipBox = styled.div``;
const LoginForm = styled.form``;

const MemberLogin = styled.div`
  margin-bottom: 24px;
`;

const InputBox = styled.div`
  margin-bottom: 18px;
  input {
    :focus {
      border: 1px solid var(--primary-color);
      offset-distance: 100%;
    }
    :focus-visible {
      border: 1px solid var(--primary-color);
      outline: 3px solid var(--outline-blue-color);
      margin: auto;
      border-radius: 4px;
    }
  }
`;

const LoginText = styled.div`
  text-align: center;
  margin: 16px 0 32px;
`;

const LoginH2 = styled.h2`
  ${Maintitle};
  color: var(--header-title-color);
  margin: 0;
`;

const LabelView = styled.label`
  ${Smalltext};
  color: var(--grey-color);
  margin-bottom: 6px;
  text-align: left;
  display: block;
`;

const LoginBtn = styled.div`
  ${Smalltext};
  margin: 24px 0;
  color: var(--black-light-color);
  ${flexcenter};
  gap: 6px;
`;

const Paragarph = styled.p`
  ${Smalltext};
  text-align: center;
  color: var(--black-light-color);
`;

const TextLink = styled.a`
  ${Smalltext};
  color: var(--primary-color);
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const ButtonWrap = styled.div`
  margin: 24px 0;
  button {
    margin: 0;
  }
`;

const PrivacyPolicy = styled.div`
  padding: 0;
`;

const Error = styled.div`
  color: var(--red-color);
  text-align: left;
  margin-top: -9px;
  margin-bottom: 5px;
`;

const ButtonText = styled.div`
  cursor: pointer;
  color: var(--primary-color);
  &:hover {
    text-decoration: underline;
  }
`;

export {
  MembershipBody,
  MembershipWrap,
  MembershipBox,
  LoginForm,
  MemberLogin,
  LoginH2,
  LoginBtn,
  Paragarph,
  TextLink,
  PrivacyPolicy,
  Error,
  LoginText,
  InputBox,
  LabelView,
  ButtonWrap,
  ButtonText
};
